var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-dialog',{ref:"dialog",attrs:{"title":"Update Device Type Mapping Router","createLabel":"Update","destinations":_vm.destinations},on:{"payload":_vm.onPayload}})}
var staticRenderFns = []

export { render, staticRenderFns }